import React from 'react';
import Alert from '@jg/alert';
import { Trans } from 'react-i18next';
import Svg from '@jg/svg';
import * as icons from '@jg/icons';
import { IFatalError } from './FatalError.d';

export const onRefreshClick = () => window.location.reload();
// eslint-disable-next-line no-shadow
const FatalError = ({ closeButtonClick, refresh }: IFatalError) => (
  <div className="jg-tc--fatal-error" data-qa="fatal-error">
    <Alert type="error" displayType="inline" className="jg-text--pull-left">
      <button
        aria-label="Close"
        className="jg-btn--invisible"
        onClick={closeButtonClick}
        type="button"
      >
        <Svg
          markup={icons.closeIcon}
          className="jg-icon jg-icon--medium-small jg-fill--nobel jg-display-ib"
        />
      </button>
      {refresh ? (
        <Trans i18nKey="content.error.api.generic.withlink">
          Something went wrong.
          <button
            data-qa="refresh-click"
            type="button"
            className="jg-btn--ghost jg-space-mrmd jg-bdn jg-color--denim"
            onClick={onRefreshClick}
          >
            <Trans i18nKey="content.error.api.generic.link" />
          </button>
        </Trans>
      ) : (
        <Trans i18nKey="global.error.fatal" />
      )}
    </Alert>
  </div>
);

export default FatalError;
